"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constans = require("../configuration/constans");

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constans.initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.SET_PRODUCT_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        productList: action.productList
      });

    case _actions.SELECTED_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedFilters: action.selectedFilters
      });

    case _actions.SET_ACTIVE_PRODUCTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeProducts: action.activeProducts
      });

    case _actions.SET_PEP_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        pepFilters: action.pepFilters
      });

    case _actions.SET_PEP_DICTIONARY:
      return _objectSpread(_objectSpread({}, state), {}, {
        dictionary: action.dictionary
      });

    case _actions.SET_PIM_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        pimConfig: action.pimConfig
      });

    case _actions.UPDATE_FILTER_COUNTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        pepFilters: action.pepFilters
      });

    case _actions.OPEN_FILTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        openFilters: action.openFilters
      });

    case _actions.SET_SELECTED_PRODUCT:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedProduct: action.selectedProduct
      });

    case _actions.SET_RELATED_ACCESSORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        relatedAccessories: action.selectedProduct
      });

    case _actions.SET_RELATED_PRODUCTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        relatedProducts: action.relatedProducts
      });

    case _actions.CHANGE_DEFAULT_IMAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        url: action.url
      });

    case _actions.SET_LAYOUT_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isMobile: action.isMobile
      });

    case _actions.SET_FAVORITE_PRODUCT:
      return _objectSpread(_objectSpread({}, state), {}, {
        favoriteProducts: action.favoriteProducts
      });

    case _actions.SET_IMAGE_SLIDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentSliderImg: action.currentSliderImg
      });

    default:
      return state;
  }
}

var _default = reducer;
exports["default"] = _default;